import './api/BASE_URL'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/styles/theme/index.css'
import './assets/styles/index.less'
// import ViomiComponents from 'viomi-components'
import Lodash from 'lodash'
import NP from 'number-precision'
import dayjs from 'dayjs'
import Filters from './filters/index'
import operate from './directive/operate'
import components from '@/components/index'
import Vant from 'vant'
import 'amfe-flexible'
import './icons/index'
import 'vant/lib/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import i18n from './lang'

import {
  initJavascriptBridge
} from '@/utils/call-native'

window._ = Lodash

Vue.use(operate)
Vue.use(Vant)
Vue.use(ElementUI, { locale })

// Vue.use(ViomiComponents)
Vue.use(components)
Object.defineProperty(Vue.prototype, '$formatDate', {
  value: function (row, column, cellValue) {
    if (cellValue) {
      return dayjs(cellValue).format('YYYY-MM-DD HH:mm:ss')
    } else {
      return ''
    }
  }
})
Object.defineProperty(Vue.prototype, '$NP', { value: NP })
Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs })
Object.defineProperty(Vue.prototype, '$goBack', {
  value: function () {
    window.history.go(-1)
  }
})

Vue.config.productionTip = false
Vue.prototype.$showLoading = function () {
  store.commit('updateLoading', true)
}
Vue.prototype.$hideLoading = function () {
  store.commit('updateLoading', false)
}

for (const key in Filters) {
  Vue.filter(key, Filters[key])
}

new Vue({
  router,
  store,
  i18n,
  computed: {
    lang() {
      return this.$store.getters.lang
    }
  },
  watch: {
    lang: {
      handler(val) {
        i18n.locale = val
      },
      immediate: true
    }
  },
  mounted() {
    initJavascriptBridge()
  },
  render: h => h(App)
}).$mount('#app')
